<template>
  <section class="ak-docs-launch" aria-label="API documentation">
    <div
      v-for="doc in docs"
      :key="doc.source"
      class="ak-docs-launch__card"
    >
      <div class="ak-docs-launch__glow" aria-hidden="true" />
      <div class="ak-docs-launch__content">
        <div class="ak-docs-launch__icon-wrap">
          <v-icon :icon="doc.icon" size="26" />
        </div>
        <div class="ak-docs-launch__copy">
          <h2 class="ak-docs-launch__title">{{ doc.title }}</h2>
          <p class="ak-docs-launch__text">{{ doc.text }}</p>
        </div>
        <v-btn
          variant="flat"
          class="ak-docs-launch__cta"
          prepend-icon="mdi-open-in-new"
          :disabled="disabled"
          @click="$emit('open', doc.source)"
        >
          {{ doc.cta }}
        </v-btn>
      </div>
    </div>
  </section>
</template>

<script setup>
defineOptions({ name: 'ApiDocsLaunchSection' })

defineProps({
  disabled: { type: Boolean, default: false },
})

defineEmits(['open'])

const docs = [
  {
    source: 'public',
    icon: 'mdi-book-open-page-variant',
    title: 'API documentation',
    text:
      'Full reference for creating leads, outbound calls, campaigns, authentication, and error handling — with curl examples and request schemas.',
    cta: 'View API Docs',
  },
]
</script>
